import React, { useEffect, useState } from "react";
import { Carousel, GetAllCarousels } from "../../../apis/AdvertisingAPI";
import VenuesCarousel from "./components/VenuesCarousel";
import { Venue } from "../../../../types/venue";
import { OrderModeType } from "../../../../types/orders";
import { getNewArrivals } from "../../../utils/VenuesUtilities";
import { I18n } from "../../../utils/i18n";

type Props = {
  latitude: number,
  longitude: number,
  userToken: string,
  onVenueClick: (event: any, venue: Venue) => void,
  venues: Venue[],
  orderMode: OrderModeType
}

const getNewArrivalCarousel = (venues: Venue[]) : Carousel => {
  return {
    id: "new-arrival",
    title: I18n.t("pages.locations.venues.carousels.new.title"),
    description: I18n.t("pages.locations.venues.carousels.new.description"),
    venue_ids: getNewArrivals(venues).map((venue) => venue.id)
  }
}

const VenuesCarousels = React.memo(({ latitude, longitude, userToken, orderMode, venues, onVenueClick }: Props) => {
  const [carousels, setCarousels] = useState<Carousel[]>([])

  useEffect(() => {
    fetchCarousels()
  }, [])

  const fetchCarousels = async () => {
    let _carousels : Carousel[] = []

    try {
      _carousels = await GetAllCarousels(latitude, longitude, userToken) || []
    } catch (error) {
    }

    setCarousels([getNewArrivalCarousel(venues), ..._carousels])
  }

  const getVenues = (venue_ids: string[]) => {
    return venues.filter(venue => venue_ids.includes(venue.id))
  }

  return (
    <div>
      {carousels.map(carousel => <VenuesCarousel id={carousel.id}
                                                 key={carousel.id}
                                                 title={carousel.title}
                                                 description={carousel.description}
                                                 onVenueClick={onVenueClick}
                                                 orderMode={orderMode}
                                                 venues={getVenues(carousel.venue_ids)}/>)}
    </div>
  );
})

export default VenuesCarousels;
